import Api from '@/api'
import humps from 'humps'
import getCurrentUserId from '@/utils/get-current-user-id'

const resource = 'portfolios'

export default {
  fetchById (portfolioId) {
    return Api.get(`/${resource}/${portfolioId}`)
  },

  updatePortfolio (portfolioId, data) {
    return Api.put(`/${resource}/${portfolioId}`, data)
  },

  fetchTargets () {
    return Api.get(`/${resource}/targets`)
  },

  fetchTransactions (portfolioId, page = 1, filters) {
    return Api.get(`/${resource}/${portfolioId}/transactions`, {
      params: humps.decamelizeKeys({ ...filters, page })
    })
  },

  update (portfolioId, data) {
    return Api.put(`/${resource}/${portfolioId}`, { portfolio: data })
  },

  updateInfos (portfolioId, infos) {
    return Api.put(`/${resource}/${portfolioId}/portfolio_infos`, {
      portfolio_infos: infos
    })
  },

  updateStatus (portfolioId, status) {
    return Api.put(`/${resource}/${portfolioId}`, { status: status })
  },

  linkLoanToRealEstate (loanId, realEstateId) {
    return Api.put(`/${resource}/${loanId}/link`, { 'real_estate_id': realEstateId })
  },

  unlinkLoanToRealEstate (loanId) {
    return Api.put(`/${resource}/${loanId}/unlink`)
  },

  fetchAnalyses (portfolioId) {
    return Api.post(`/${resource}/${portfolioId}/analyses/all?async=true`)
  },

  triggerReporting(portfolioId) {
    return Api.post(`/${resource}/${portfolioId}/reportings`)
  },

  getAnalysis (portfolioId) {
    return Api.get(`/${resource}/${portfolioId}/analysis`)
  },

  fetchSectorsHistory (portfolioId, from, to) {
    const params = []
    if (from) params.push(`start_date=${from}`)
    if (to) params.push(`end_date=${to}`)

    return Api.get(`/users/${getCurrentUserId()}/portfolios/${portfolioId}/sector_histories${params.length ? '?' : ''}${params.join('&')}`)
  },

  unlinkPortfolioAndExternalId (idManagementContract) {
    return Api.post(`/management_contracts/${idManagementContract}/unlink`)
  },

  updatePortfolioWithExternalId (idManagementContract, portfolioId, bankContractId) {
    return Api.post(`/management_contracts/${idManagementContract}/link`, { portfolioId, bankContractId })
  }
}
